/* src/app/components/auth/auth-shell.css */
:host {
  display: block;
}
.auth-shell {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--gray-50);
}
.auth-card {
  width: 100%;
  max-width: 420px;
  background: var(--bg-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}
.auth-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 22px 24px;
  background: var(--navy-600);
}
.auth-brand-mark {
  height: 34px;
  width: auto;
}
.auth-brand-word {
  color: var(--fg-on-navy);
  font-size: var(--text-2xl);
  font-weight: 700;
  letter-spacing: 0.01em;
}
.auth-body {
  padding: 26px 28px 28px;
}
.auth-title {
  margin: 0 0 6px;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--fg-1);
}
.auth-lede {
  margin: 0 0 18px;
  color: var(--fg-3);
  font-size: 0.9rem;
  line-height: 1.5;
}
.auth-body .form-group {
  margin-bottom: 14px;
}
.auth-body label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--fg-2);
}
.auth-actions {
  display: flex;
  gap: 10px;
  margin-top: 18px;
}
.auth-actions .btn {
  flex: 1;
}
.auth-links {
  margin-top: 16px;
  text-align: center;
  font-size: 0.85rem;
}
.auth-links a {
  color: var(--navy-600);
  cursor: pointer;
  text-decoration: none;
}
.auth-links a:hover {
  text-decoration: underline;
}
.auth-note {
  margin-top: 14px;
  color: var(--fg-3);
  font-size: 0.82rem;
  line-height: 1.5;
}
.auth-code-input {
  letter-spacing: 0.35em;
  text-align: center;
  font-size: 1.25rem;
  font-variant-numeric: tabular-nums;
}
.auth-qr {
  display: block;
  margin: 0 auto 12px;
  width: 190px;
  height: 190px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
}
.auth-secret {
  display: block;
  margin: 0 auto 14px;
  padding: 8px 10px;
  background: var(--gray-100);
  border-radius: var(--radius-sm);
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    monospace;
  font-size: 0.85rem;
  word-break: break-all;
  text-align: center;
  color: var(--fg-2);
}
.auth-recovery {
  margin: 0 0 14px;
  padding: 12px;
  background: var(--gray-50);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 14px;
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    monospace;
  font-size: 0.9rem;
  color: var(--fg-1);
}
.auth-warning {
  margin: 0 0 14px;
  padding: 10px 12px;
  background: var(--warning-bg);
  border: 1px solid var(--warning-border);
  border-radius: var(--radius-md);
  color: var(--gold-700);
  font-size: 0.85rem;
  line-height: 1.5;
}
.auth-method {
  display: block;
  width: 100%;
  margin-bottom: 10px;
  padding: 14px 16px;
  text-align: left;
  background: var(--bg-surface);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  cursor: pointer;
}
.auth-method:hover {
  border-color: var(--navy-600);
  background: var(--gray-50);
}
.auth-method strong {
  display: block;
  color: var(--fg-1);
  font-size: 0.95rem;
}
.auth-method span {
  display: block;
  margin-top: 3px;
  color: var(--fg-3);
  font-size: 0.82rem;
  line-height: 1.45;
}
.auth-done {
  text-align: center;
  padding: 8px 0 4px;
}
/*# sourceMappingURL=auth-shell.css.map */
